// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, ActivityNotesDialogStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import _ from 'lodash';
import Button from '@mui/material/Button';
import { sendDigits } from 'src/features/Twilio/TwilioBase';

const DialPad = () => {
    const sendDigit = (digit: string) => {
        sendDigits(digit);
    }
        return (
            <Box sx={{ width: '200px' }}>
                <Grid container spacing={1}>
                    
                        <Grid item xs={12} md={4} alignItems="center" sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Button value="1" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('1')}>
                                1
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button value="2" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('2')}>
                                2 <br />ABC 
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button value="3" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('3')}>
                                3<br />DEF
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="4" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('4')}>
                                4<br />GHI
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="5" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('5')}>
                                5<br />JKL
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="6" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('6')}>
                                6<br />MNO
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="7" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('7')}>
                                7<br />PQRS
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="8" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('8')}>
                                8<br />TUV
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="9" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('9')}>
                                9 <br />WXYZ
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="*" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('*')}>
                                    *
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="0" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('0')}>
                                    0
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={4} alignItems="center" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                            <Button size='small' value="#" variant="outlined" color="info" sx={{ width: '60px', height: '60px' }} onClick={() => sendDigit('#')}>
                                    #
                            </Button>
                        </Grid>
                </Grid>
            </Box>
        )
    

}

export { DialPad }

export default DialPad;